import { Component, inject, input } from '@angular/core';
import { AufgabenTyp, AufgabeVersandTaetigkeit, AufgabeZertifikatTaetigkeit } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

@Component({
	selector: 'schir-int-client-aufgabe-zertifikatsauszug-editor',
	templateUrl: './aufgabe-zertifikatsauszug-editor.component.html',
	styleUrls: ['./aufgabe-zertifikatsauszug-editor.component.scss'],
	standalone: false,
})
export class AufgabeZertifikatsauszugEditorComponent {
	private formService = inject(CreateAufgabeFormService);

	readonly excludeEingetragenerEigentuemer = input(true);

	protected readonly taetigkeiten = AufgabeZertifikatTaetigkeit;
	protected readonly versandTaetigkeit = AufgabeVersandTaetigkeit;

	protected formGroup = this.formService.form.controls.ZERTIFIKATSAUSZUG;
	protected bodyControls = this.formGroup.controls.body.controls;

	toggleTaetigkeitAndSendenControls(zertifikatTaetigkeit: AufgabeZertifikatTaetigkeit) {
		if (zertifikatTaetigkeit === AufgabeZertifikatTaetigkeit.NOTIZ) {
			this.bodyControls.taetigkeit.disable();
			this.bodyControls.empfaenger.disable();
			this.bodyControls.vorabPerFax.disable();
		} else {
			this.bodyControls.taetigkeit.enable();
			this.bodyControls.empfaenger.enable();
			this.bodyControls.vorabPerFax.enable();
		}
		this.toggleFaxEmpfaengerControls(this.bodyControls.vorabPerFax.value);
	}

	toggleFaxEmpfaengerControls(enable: boolean) {
		if (enable) {
			this.bodyControls.faxEmpfaenger.enable();
		} else {
			this.bodyControls.faxEmpfaenger.disable();
		}
	}

	protected readonly AufgabenTyp = AufgabenTyp;
}
